import { render, staticRenderFns } from "./PowerRankingsIssues.vue?vue&type=template&id=0a88e5da&scoped=true&"
import script from "./PowerRankingsIssues.vue?vue&type=script&lang=js&"
export * from "./PowerRankingsIssues.vue?vue&type=script&lang=js&"
import style0 from "./PowerRankingsIssues.vue?vue&type=style&index=0&id=0a88e5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a88e5da",
  null
  
)

export default component.exports